var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.808594,
    y: 0.5,
    width: 24.8621,
    height: 24,
    rx: 4.5,
    fill: "white",
    stroke: "#EFF0F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3058 11.8174V15.9123M15.0357 11.8174V15.9123M8.21094 9.08755H19.1305M18.448 9.08755L17.8563 17.3741C17.8318 17.7185 17.6777 18.0408 17.4251 18.2761C17.1724 18.5113 16.84 18.6422 16.4948 18.6421H10.8466C10.5014 18.6422 10.169 18.5113 9.91635 18.2761C9.66372 18.0408 9.50962 17.7185 9.48511 17.3741L8.89341 9.08755H18.448ZM15.7181 9.08755V7.04014C15.7181 6.85913 15.6462 6.68555 15.5182 6.55756C15.3902 6.42957 15.2167 6.35767 15.0357 6.35767H12.3058C12.1248 6.35767 11.9512 6.42957 11.8232 6.55756C11.6952 6.68555 11.6233 6.85913 11.6233 7.04014V9.08755H15.7181Z",
    stroke: "#3F3F46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.3eb7f9a1791908b75cea20954ee811af.svg";
export { ForwardRef as ReactComponent };